<template>
  <GenericDrawer
    colorKey="bgDrawerContent"
    :isOpen="true"
    :isSubDrawer="true"
    :topLinks="topLinks"
    :bottomLinks="bottomLinks"
    :key="drawerKey"
  >
    <template v-slot:prepend>
      <v-container>
        <ProjectInput v-model="selectedProject" />
      </v-container>
    </template>
  </GenericDrawer>
</template>

<script>
import { PROJECT_DRAWER_BOTTOM, PROJECT_DRAWER_TOP, PROJECT_DRAWER_TOP_PCQ } from "@/utils/links"

export default {
  name: "ProjectDrawer",
  components: {
    GenericDrawer: () => import("@/components/layouts/core/GenericDrawer.vue"),
    ProjectInput: () => import("@/components/inputs/ProjectInput.vue")
  },
  data: () => ({
    // topLinks: PROJECT_DRAWER_TOP,
    // topLinks: [],
    bottomLinks: PROJECT_DRAWER_BOTTOM
  }),
  computed: {
    showPcqDsi() {
      return this.$store.state.app.project.show_pcq_dsi
    },
    topLinks() {
      return this.showPcqDsi ? PROJECT_DRAWER_TOP_PCQ : PROJECT_DRAWER_TOP
    },
    drawerKey() {
      return this.showPcqDsi
    },
    selectedProject: {
      get() {
        return this.$store.state.app.project
      },
      set(v) {
        this.$store.commit("app/setProject", v)
      }
    }
  }
}
</script>
